import { render, staticRenderFns } from "./tabCo2.vue?vue&type=template&id=42ed24b2&scoped=true"
import script from "./tabCo2.vue?vue&type=script&lang=js"
export * from "./tabCo2.vue?vue&type=script&lang=js"
import style0 from "./tabCo2.vue?vue&type=style&index=0&id=42ed24b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ed24b2",
  null
  
)

export default component.exports